
export const getBase64 = (data) => {
    console.log('data to convert base 64 ', data);
    return '';
}
